$(->
  $(document).on 'click', 'a[data-outmatch]', (e)->
    e.preventDefault()
    the_link = $(this)

    if $('#outmatch-resp')
      $('#outmatch-resp').remove()

    $.ajax({
      url: "/outmatch_link?app_id=#{the_link.data('app-id')}&user_id=#{the_link.data('user-id')}&completed_form_id=#{the_link.data('cf-id')}"
      type: 'POST',
      dataType: 'json'
      success: (data)->
        wrap = $('#outmatch-wrap')
        wrap.append(responseDiv('green', false))
      error: (xhr, status, err)->
        msg = xhr.responseJSON
        wrap = $('#outmatch-wrap')
        wrap.append(responseDiv('red', true, msg))
    })

    responseDiv = (color, isErr, msg) ->
      res = "<div id='outmatch-resp' style='color:#{color};padding:5px;'>"
      if isErr
        res += "Error: #{msg}"
      else
        res += 'Email sent!'
      res += '</div>'
)
